import { HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { CourseDeleteUseCaseInterface } from 'domain/usecases';

export class RemoteCourseDelete implements CourseDeleteUseCaseInterface {
  constructor(
    private readonly url: string,
    private readonly httpClient,
  ) {}

  async execute(
    params: CourseDeleteUseCaseInterface.Params,
  ): Promise<CourseDeleteUseCaseInterface.Result> {
    const httpResponse = await this.httpClient.request({
      url: this.url + '/' + params.id,
      method: 'delete',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
